var map = {
	"./de.json": 47206,
	"./en.json": 358014,
	"./es.json": 470101,
	"./fr.json": 723571,
	"./it.json": 880888,
	"./ja.json": 338721,
	"./ko.json": 462646,
	"./pl.json": 805789,
	"./pt.json": 91169,
	"./ru.json": 551319,
	"./uk.json": 585392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 644913;